/**
 * @typedef {Object} IntlTelInputInstance
 * @property {function(): string} getNumber - Get the full phone number
 * @property {function(): boolean} isValidNumber - Check if number is valid
 * @property {function(string): void} setCountry - Set country code
 */

/**
 * Initialize international phone input fields
 * @param {HTMLInputElement} input - Phone input element
 * @returns {IntlTelInputInstance|null} Instance or null if initialization failed
 */
function initPhoneInput(input) {
  if (!window.intlTelInput) return null;

  try {
    const iti = window.intlTelInput(input, {
      initialCountry: 'fr',
      preferredCountries: ['fr', 'be', 'ch', 'lu'],
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.8.1/build/js/utils.js',
      i18n: window.intlTelInputGlobals?.i18n?.fr || {},
      autoPlaceholder: 'polite',
      formatOnDisplay: true,
      separateDialCode: true,
      nationalMode: false,
      customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
        return selectedCountryPlaceholder;
      }
    });

    input.addEventListener('blur', () => {
      if (input.value.trim() && iti.isValidNumber()) {
        input.value = iti.getNumber();
      }
    });

    return iti;
  } catch (error) {
    return null;
  }
}

/**
 * Initialize all phone inputs on page load
 */
function initAllPhoneInputs() {
  const phoneInputs = document.querySelectorAll('input[type="tel"][data-phone-input]');
  
  for (const input of phoneInputs) {
    initPhoneInput(input);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllPhoneInputs);
} else {
  initAllPhoneInputs();
}